import { Injectable } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { environment } from "../../../../../../environments/environment";
import { Observable } from "rxjs/Observable";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import { saveAs } from 'file-saver/FileSaver';

@Injectable()
export class WarningUserService {
  headers: Headers;
  url = environment.qrcode_url;
  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  getList(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/warning/user`, {
        headers: this.headers,
        params: query,
      })
      .map((res: any) => res.json())
      .catch((err: any) => {
        throw this.apiEvsService.checkErr(err);
      });
  }

  public getTokenDownloadWarningUser(query){
    return this.apiEvsService.getExcel2('/qr_aps/scan/export', query)
  }

  public saveToFileSystem(response, __type, filename) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');

    if (contentDispositionHeader !== null) {
      const parts: string[] = contentDispositionHeader.split(';');
      //const filename = parts[1].split('=')[1];
      const blob = new Blob([response._body], { type: __type });
      console.log(111, blob)
      saveAs(blob, filename);
    } else {
      // handling download condition if content disposition is empty
      const blob = new Blob([response._body], { type: __type });
      console.log(222, blob)

      saveAs(blob, filename);
    }

  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/warning-overflow/services/warning-user.service.ts